<template>
    <div v-if="analysis">
        <bootstrap-box v-if="!analysis.isReadOnly">
            <template v-slot:body>
                <button class="btn btn-primary pull-right" @click="displayFinalizePrompt = true">
                    {{ resource('Button_Finalize') }}
                </button>

                <button class="btn btn-primary pull-right mr-3" @click="saveAnswers">
                    {{ resource('Button_Save') }}
                </button>
            </template>
        </bootstrap-box>
        
        <bootstrap-box v-for="label in analysis.labels">
            <template v-slot:body>
                <div class="row">
                    <div class="col-2 fields ucid">
                        <template v-for="(value, name) in label.startUcid">
                            <span>{{name}}: {{value}}</span>
                        </template>
                    </div>

                    <div class="col-4">
                        <div v-for="pathCollection in label.paths" class="pathcollection">
                            <template v-for="path in pathCollection">
                                <div class="fields">
                                    <template v-for="(value, name) in path">
                                        <span>{{name}}: {{value}}</span>
                                    </template>
                                </div>

                                <i  v-if="path !== pathCollection.at(-1)"
                                    class="fas fa-arrow-right mt-auto mb-auto"
                                />
                            </template>
                        </div>
                    </div>

                    <div class="col-2 fields ucid">
                        <template v-for="(value, name) in label.endUcid">
                            <span>{{name}}: {{value}}</span>
                        </template>
                    </div>

                    <div class="col-4">
                        <question v-for="answer in label.answers"
                                  
                                  class="form-group"

                                  v-model="answer.value"
                                  :question="questionLookup[answer.questionId]"
                                  :readonly="analysis.isReadOnly"
                        />
                    </div>
                </div>
            </template>
        </bootstrap-box>
        
        <bootstrap-box v-if="!analysis.isReadOnly">
            <template v-slot:body>
                <button class="btn btn-primary pull-right" @click="displayFinalizePrompt = true">
                    {{ resource('Button_Finalize') }}
                </button>
                
                <button class="btn btn-primary pull-right mr-3" @click="saveAnswers">
                    {{ resource('Button_Save') }}
                </button>
            </template>
        </bootstrap-box>
        
        <prompt v-if="displayFinalizePrompt"
                v-bind="finalizePrompt"

                @yes="finish"
                @hidden="displayFinalizePrompt = false"
        />
    </div>
</template>

<script>
import api from './api';

import resourcesMixin from "@core/Util/Mixins/resources";
import Loader from "@core/Util/loader";
import { bootstrapSuccessGrowl, bootstrapDangerGrowl } from "@core/Util/growler";

import BootstrapBox from "@core/Components/Util/BootstrapBox";
import Prompt from '@core/Components/Util/Prompt';
import Question from "./Question";

export default {
    name: "Index",
    
    components: {
        BootstrapBox,
        Prompt,
        Question
    },
    
    mixins: [resourcesMixin],

    props: {
        analysisId: {
            type: String,
            required: true
        }
    },
    
    data() {
        return {
            analysis: undefined,
            displayFinalizePrompt: false
        }
    },
    
    computed: {
        questionLookup() {
            const lookup = {};
            this.analysis.questions.forEach(question => lookup[question.id] = question);
            return lookup;
        },
        
        finalizePrompt() {
            const hasUnansweredQuestions = this.analysis.labels.flatMap(a => a.answers)
                .some(a => !a.value);
            
            const body = hasUnansweredQuestions ? 
                this.resource('UcidAnalysis_FinalizePrompt_Body_NotAllQuestionsAnswered') : 
                this.resource('UcidAnalysis_FinalizePrompt_Body');
            
            return {
                title: this.resource('UcidAnalysis_FinalizePrompt_Title'),
                body: body,
                icon: 'fa fa-save'
            }
        }
    },
    
    async created() {
        this.analysis = await api.getAnalysis(this.analysisId);
    },
    
    methods: {
        async saveAnswers() {
            Loader.show();
            
            try {
                const flattenedAnswers = this.analysis.labels.flatMap(a => a.answers);

                await api.updateAnalysisAnswers(
                    this.analysisId,
                    flattenedAnswers
                );

                bootstrapSuccessGrowl(this.resource('UcidAnalysis_AnswersSaved'));
            } catch(e) {
                bootstrapDangerGrowl(e);
            }

            Loader.hide();
        },
        
        async finish() {
            Loader.show();

            try {
                //First save our answers
                const flattenedAnswers = this.analysis.labels.flatMap(a => a.answers);
                
                await api.updateAnalysisAnswers(
                    this.analysisId,
                    flattenedAnswers
                );

                //Mark our analysis finished
                await api.finishAnalysis(this.analysisId);

                bootstrapSuccessGrowl(this.resource('UcidAnalysis_AnalysisFinished'));
            } catch(e) {
                bootstrapDangerGrowl(e);
                Loader.hide();
                return;
            }

            //Redirect to index page to get assigned new analysis
            window.location = '/ucidanalysis/';
        }
    }
}
</script>

<style scoped>
    ::v-deep .box-header {
        display: none;
    }

    .fields {
        display: flex;
        flex-flow: column;
    }

    .pathcollection {
        display: flex;
        flex-flow: row;
        column-gap: 20px;
        overflow-x: auto;
        
        margin-bottom: 15px;
    }
    
    .pathcollection .fields {
        min-width: fit-content;
        
        justify-content: center;

        background-color: #cccccc;
        border-radius: 5px;
        padding: 5px;
    }
</style>